import React, { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/en-gb';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { API_DATE_FORMAT, DISPLAY_DATE_FORMAT } from '../../utils/date';

interface DatePickerProps {
  value?: string | null;
  onChange: (value: string) => void;
  min?: string;
  max?: string;
  disabled?: boolean;
  error?: boolean;
  placeholder?: string;
  inputRef?: React.Ref<HTMLInputElement>;
}

const StandardDatePicker: React.FC<DatePickerProps> = ({
  value,
  onChange,
  min,
  max,
  disabled = false,
  error = false,
  placeholder = DISPLAY_DATE_FORMAT,
  inputRef,
}) => {
  const [pickerValue, setPickerValue] = useState<Dayjs | null>(value ? dayjs(value) : null);

  useEffect(() => {
    setPickerValue(value ? dayjs(value) : null);
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      <MuiDatePicker
        value={pickerValue}
        onChange={(date) => {
          setPickerValue(date);
          if (date === null) onChange('');
          else if (date.isValid()) onChange(date.format(API_DATE_FORMAT));
        }}
        minDate={min ? dayjs(min) : undefined}
        maxDate={max ? dayjs(max) : undefined}
        disabled={disabled}
        format={DISPLAY_DATE_FORMAT}
        slotProps={{
          textField: {
            fullWidth: true,
            size: 'small',
            error,
            inputRef,
            inputProps: { placeholder },
            sx: {
              width: '100%',
              minWidth: 0,
              '& .MuiInputBase-root, & .MuiOutlinedInput-root, & .MuiPickersInputBase-root, & .MuiPickersOutlinedInput-root': {
                width: '100%',
                minWidth: 0,
                height: '42px',
                boxSizing: 'border-box',
                backgroundColor: '#f3f4f6',
                borderRadius: '0.375rem',
              },
              '& .MuiInputBase-input, & .MuiPickersInputBase-sectionsContainer': {
                minWidth: 0,
                fontSize: '1rem',
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default StandardDatePicker;
